import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { compose } from 'ramda';
import { withTranslation } from 'react-i18next';
import MySubscriptionsContainer from './containers/mySubscriptionContainer';

const useStyles = makeStyles((theme) => ({
  mySubscriptionContainer: {
    minHeight: '500px',
    padding: 0,
  },
}));

function SubscriptionInfo(props) {
  const {
    productExternalReference,
    productExternalReferenceType,
    stripePromise,
    cdStripeHeader,
    staticApiKey,
    staticApiUrl,
  } = props;
  const classes = useStyles();

  return (
    <Container className={classes.mySubscriptionContainer}>
      <MySubscriptionsContainer
        productExternalReference={productExternalReference}
        productExternalReferenceType={productExternalReferenceType}
        stripePromise={stripePromise}
        cdStripeHeader={cdStripeHeader}
        staticApiKey={staticApiKey}
        staticApiUrl={staticApiUrl}
      />
    </Container>
  );
}

export default compose(withTranslation())(SubscriptionInfo);
